import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/close_icon.svg'
import _imports_1 from '@/assets/bad.svg'
import _imports_2 from '@/assets/arrow_right.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = {
  key: 0,
  class: "account-type-error-popup-container",
  "cy-data": "popup"
}
const _hoisted_4 = { class: "account-type-error-popup" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "account-type-error-popup__icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_8 = { class: "account-type-error-popup__header" }
const _hoisted_9 = { class: "account-type-error-popup__text" }
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = { class: "container__standard-header fs-15" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "account-card__content" }
const _hoisted_15 = {
  key: 0,
  class: "account-card__content__desc"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "account-card__content__icon",
  src: _imports_2,
  alt: "",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = { class: "account-card__content__item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      (_ctx.accountTypes.length === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.stepAccountTypeHeaderOnlyStock`)), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.stepAccountTypeHeader`)), 1)
          ], 64))
    ]),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.isAccountTypeErrorPopupOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "account-type-error-popup__close-btn",
                  "aria-label": "Close popup",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAccountTypeErrorPopupClose && _ctx.handleAccountTypeErrorPopupClose(...args)))
                }, _hoisted_6),
                _hoisted_7,
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.errorPopupHeader`)), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.accountTypeError), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "account-type-error-popup__understand-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAccountTypeErrorPopupClose && _ctx.handleAccountTypeErrorPopupClose(...args)))
                }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.${_ctx.accountTypes.length === 1 ? 'errorPopupButtonOne' : 'errorPopupButtonTwo'}`
                            )), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createElementVNode("p", _hoisted_11, [
        (_ctx.accountTypes.length === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseAccountTypeInfoOnlyStock`)), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseAccountTypeInfo`)), 1)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountTypes, (account) => {
          return (_openBlock(), _createElementBlock("label", {
            key: account.key,
            class: _normalizeClass([
                        'account-card',
                        _ctx.hasAccountTypeError ? 'has-error' : '',
                    ])
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.accountType = $event)),
              type: "radio",
              name: "accountType",
              value: account.key
            }, null, 8, _hoisted_13), [
              [_vModelRadio, _ctx.formData.accountType]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(account.title)), 1),
              (account.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(account.description)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(account.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", { key: item }, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(item)), 1)
                  ]))
                }), 128))
              ])
            ])
          ], 2))
        }), 128))
      ]),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.ACCOUNT_TYPE,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        data: _ctx.formData,
        class: "button button--submit",
        disabled: !_ctx.formData.accountType,
        onClick: _cache[3] || (_cache[3] = 
                    () =>
                        _ctx.amplitudeSendEvent(
                            _ctx.AmplitudeAnalyticsEvents.accountType
                                .CHOOSE_ACCOUNT_TYPE_CONTINUE
                        )
                )
      }, null, 8, ["action", "button-value", "data", "disabled"])
    ], 40, _hoisted_10)
  ]))
}